import clsx from "clsx";
import Link from "next/link";
import { FC } from "react";
import { Image } from "@/components/Image/Image";
import { pagesPath } from "@/lib/$path";
import { PostSearch } from "./PostSearch/PostSearch";

interface Props {
  isArticle?: boolean;
}

export const HeaderBlack: FC<Props> = ({ isArticle }) => {
  return (
    <nav
      className={clsx(
        "fixed z-10 flex h-[57px] w-full items-center bg-black !py-3",
        isArticle ? "article-container !py-0" : "kdotdev-container",
      )}
    >
      <div className="flex content-center items-center">
        <Link href={pagesPath.kdotdev.pages._page_number(1).$url()} className="h-[27px]">
          <Image src="/images/logo/inline-white.png" height={97} width={369} alt="logo" className="h-[27px] w-auto" />
        </Link>
        <Link className="ml-2 mt-[10px] font-noto text-base font-bold text-white" href={pagesPath.$url()}>
          produced by KDOT
        </Link>
      </div>
      <PostSearch />
    </nav>
  );
};
